import { useEffect, useState } from "react";
import Section from "../../../../components/base/Section";
import Layout from "../../../../components/layouts/Layout";
import { DataTable, DataTableField } from "../../../../components/data/DataTable";
import { API_ROUTES } from "../../../../core/Constants";
import DataTableActiveToggle from "../../../../components/data/DataTableActiveToggle";
import FlexRow from "../../../../components/base/FlexRow";
import Div from "../../../../components/base/Div";
import Icon from "../../../../components/base/Icon";
import { setPage, toPrettyDate } from "../../../../core/Global";
import Indicator from "../../../../components/base/Indicator";
import RedirectRuleForm from "../components/RedirectRuleForm";
import { RedirectCallsDateTypes, RedirectCallsItem } from "../models/RedirectRuleModels";
import DataItem from "../../../../models/DataItem";



export default function RedirectCallsRulesList() {


    const [createForm, createFormSet] = useState<boolean>(false)
    const [editForm, editFormSet] = useState<boolean>(false)
    const [selectedItem, selectedItemSet] = useState<RedirectCallsItem>()

    useEffect(() => {
        setPage("Redirect Rules")
    }, [])

    const [refresh, refreshSet] = useState<boolean>()
    useEffect(() => {
        if (refresh) {
            setTimeout(() => {
                refreshSet(false);
            }, 1000);
        }
    }, [refresh])

    const [WeekDays] = useState<DataItem[]>([
        {
            id: "1",
            name: "Monday"
        },
        {
            id: "2",
            name: "Tuesday"
        },
        {
            id: "3",
            name: "Wednesday"
        },
        {
            id: "4",
            name: "Thursday"
        },
        {
            id: "5",
            name: "Friday"
        },
        {
            id: "6",
            name: "Saturday"
        },
        {
            id: "0",
            name: "Sunday"
        }
    ])

    const NameItem = (data: RedirectCallsItem) => (
        <FlexRow>
            <Div limitedText maxWidth={100} title={data.name}>
                {data.name}
            </Div>
            <a href="#" className="ms-2"
                onClick={e => {
                    e.preventDefault()
                    selectedItemSet(data)
                    editFormSet(true)
                }}>
                <Icon icon="edit" size={12} />
            </a>
        </FlexRow>
    )

    const PhoneItem = (data: RedirectCallsItem) => (
        <div>
            {data.phone?.phoneFriendly}
        </div>
    )

    const DateType = (data: RedirectCallsItem) => (
        <div>
            {
                data.dateType == RedirectCallsDateTypes.DateRange &&
                <>
                    <div>
                        Date Range
                    </div>
                    <FlexRow className="fs-8 text-gray-600">
                        <Icon icon="clock" type="solid" className="me-1" />
                        <span>
                            {data.rangeDates?.fromText}
                        </span>
                        <span>-</span>
                        <span>
                            {data.rangeDates?.toText}
                        </span>
                    </FlexRow>
                </>
            }
            {
                data.dateType == RedirectCallsDateTypes.WeekDays &&
                <>
                    <div>
                        Week Days
                    </div>
                    <FlexRow className="fs-8 text-gray-600">
                        <Icon icon="clock" type="solid" className="me-1" />
                        <span className="me-1">
                            {WeekDays.filter(f => f.id == data.weekDayFrom?.toString())[0].name} {data.weekDayFromTimeStr}
                        </span>
                        <span className="me-1">-</span>
                        <span>
                            {WeekDays.filter(f => f.id == data.weekDayTo?.toString())[0].name} {data.weekDayToTimeStr}
                        </span>
                    </FlexRow>
                </>
            }
        </div>
    )

    const CreatedItem = (data: RedirectCallsItem) => (
        <div>
            <div className='d-flex align-items-center'>
                {toPrettyDate(data.createdAt)}
            </div>
            {
                data.creatorUser &&
                <FlexRow className='fs-8 mt-1'>
                    <div>
                        <Icon icon="user" className="me-2" size={10} type="solid" />
                    </div>
                    <div className="fs-8">
                        By: {data.creatorUser.fullName}
                    </div>
                </FlexRow>
            }

        </div>
    )

    return (
        <Layout wide>
            <Section fluid>

                <DataTable
                    objectName="Rule"
                    apiRoute={API_ROUTES.RedirectRules}
                    edit delete
                    addCustom={() => {
                        createFormSet(true)
                    }}
                    editCustom={() => {

                    }}
                    refresh={refresh}>

                    <DataTableField title="" width={50}>
                        <DataTableActiveToggle route={API_ROUTES.RedirectRules} />
                    </DataTableField>

                    <DataTableField title="Name">
                        <NameItem />
                    </DataTableField>

                    <DataTableField title="Redirect To">
                        <PhoneItem />
                    </DataTableField>

                    <DataTableField title="Date Type">
                        <DateType />
                    </DataTableField>

                    <DataTableField title="Created">
                        <CreatedItem />
                    </DataTableField>
                </DataTable>

            </Section>


            {
                createForm &&
                <RedirectRuleForm
                    onClose={() => createFormSet(false)}
                    onSave={() => refreshSet(true)} />
            }

            {
                editForm && selectedItem &&
                <RedirectRuleForm model={selectedItem}
                    onSave={() => refreshSet(true)}
                    onClose={() => {
                        editFormSet(false)
                        selectedItemSet(undefined)
                    }} />
            }



        </Layout>
    )
}